import { render, staticRenderFns } from "./CalendarEventPage.vue?vue&type=template&id=35b2e018&scoped=true&lang=pug&"
import script from "./CalendarEventPage.vue?vue&type=script&lang=ts&"
export * from "./CalendarEventPage.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarEventPage.vue?vue&type=style&index=0&id=35b2e018&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b2e018",
  null
  
)

export default component.exports